import React from 'react'
import styled from 'styled-components'
import { CiWallet, CiBank } from "react-icons/ci"

export const PaymentMethodButtons = ({ 
    selectedMethod, 
    onMethodSelect 
}) => {
    const paymentMethods = [
        { 
            icon: <CiWallet size={22}/>, 
            label: 'Mobile wallet (GHC)', 
            value: 'Mobile wallet' 
        },
        { 
            icon: <CiBank size={22}/>, 
            label: 'Bank Transfer (GHC)', 
            value: 'Bank Transfer GHC' 
        },
        { 
            icon: <CiBank size={22}/>, 
            label: 'Bank Transfer (USD)', 
            value: 'Bank Transfer USD' 
        }
    ];

    return (
        <StyledPaymentMethod className='payment-method'>
            <h6>Payment Method:</h6>
            <div className='button-container'>
                {paymentMethods.map((method) => (
                    <button 
                        key={method.value}
                        className={`method ${selectedMethod === method.value ? 'selected' : ''}`}
                        onClick={() => onMethodSelect(method.value)}
                    >
                        {method.icon}
                        {method.label}
                    </button>
                ))}
            </div>
        </StyledPaymentMethod>
    );
};

const StyledPaymentMethod = styled.div`
    .button-container {
        width: 100%;
        display: flex;
        gap: 0.3em;

        .method {
            background-color: white;
            width: 33%;
            aspect-ratio: 2;
            border: 0.5px solid #E1E6EF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            padding: 0.8rem;
        }

        svg {
            left: 0;
        }
        
        .method:hover, .method.selected {
            border-color: #CA9D3B;
        }

        .method.selected {
            background-color: #EFF3F6;
            border: none;
        }
    }
`;

export default PaymentMethodButtons;